<template>
  <page>
    <google-pixel></google-pixel>
    <content-container>
      <account-content-heading></account-content-heading>
      <email-not-verified-warning></email-not-verified-warning>
      <app-content></app-content>
    </content-container>
    <router-view class="account-actions" name="actions" />
  </page>
</template>

<script>
import AppContent from '@/views/AppContent.vue';
import EmailNotVerifiedWarning from '@/components/account/EmailNotVerifiedWarning.vue';
import GooglePixel from '@/components/common/GooglePixel.vue';
import Page from '@/components/common/Page.vue';
import ContentContainer from '@/components/common/ContentContainer.vue';
import AccountContentHeading from '@/components/account/AccountContentHeading.vue';

export default {
  components: {
    AppContent,
    EmailNotVerifiedWarning,
    GooglePixel,
    Page,
    ContentContainer,
    AccountContentHeading,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/variables';
@import '~@/assets/styles/metrics';
@import '~@/assets/styles/breakpoints';

.switcher {
  margin: $base 0;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

@media (max-width: $header-breakpoint) {
  .switcher {
    display: none;
  }

  .account-content {
    display: flex;
    align-items: center;
  }
}
</style>
